import React from 'react';
import {Text, View} from 'react-native';
import {styles} from './styles';

interface UnorderedListProps {
  items: Array<string | React.ReactNode>;
  type?: 'bullet' | 'arrow';
}
export const UnorderedList = ({items, type = 'bullet'}: UnorderedListProps) => {
  return (
    <View style={styles.listContainer}>
      {items.map((item, index) => (
        <View key={index} style={styles.listItem}>
          <Text style={styles.bullet}>{type === 'arrow' ? '▶' : '•'}</Text>
          <Text style={styles.itemText}>{item}</Text>
        </View>
      ))}
    </View>
  );
};
